module.exports = __webpack_public_path__ + "img/slide-2-mob.0c11e28.webp";